@if (header) {
  <h1 data-test="process-summary-title">{{ header }}</h1>
}
<ng-content select=".error-container" />
<p class="mb-5 mb-md-6" data-test="process-summary-description" [translate]="description"></p>
<div class="mb-4 mb-md-6">
  <mwe-address [address]="address" />
</div>

@if (processTitle) {
  <div class="expander-item mt-4 mb-4">
    <h6 class="ml-3" data-test="process-summary-title" [translate]="processTitle"></h6>
  </div>
}

@if (multiProductCards) {
  <mwe-multi-product-card-container class="d-block mb-4" [multiProductCards]="multiProductCards" [isSliderVisible]="false" />
}

<ng-content select=".additional-stuff" />
